import { render, staticRenderFns } from "./MobileNote.vue?vue&type=template&id=08017fd7&scoped=true"
import script from "./MobileNote.vue?vue&type=script&lang=js"
export * from "./MobileNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08017fd7",
  null
  
)

export default component.exports